// Сворачиваемые группы левого меню консоли.
//
// Меню выросло до шести групп и двух десятков пунктов — длинную колонку
// приходилось листать. Группу можно свернуть нажатием на заголовок; выбор
// запоминается в localStorage (в try/catch: приватный режим или запрет
// хранилища не должны ломать меню). Группа, где открыт текущий раздел,
// разворачивается сама при переходе в неё — активный пункт всегда виден.
//
// Решение заказчика 26.09.2026: по умолчанию ВСЕ группы свёрнуты и раскрываются
// по нажатию; раскрыта только группа открытого раздела. Поэтому храним список
// РАСКРЫТЫХ групп (новый ключ - прежний список свёрнутых больше не читаем,
// иначе у операторов меню осталось бы развёрнутым).

export const NAV_EXPANDED_STORAGE_KEY = "osmix_admin_nav_expanded"

type StorageLike = Pick<Storage, "getItem" | "setItem">

const defaultStorage = (): StorageLike | null => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null
  } catch {
    return null
  }
}

export function readExpandedGroups(storage: StorageLike | null = defaultStorage()): string[] {
  try {
    const raw = storage?.getItem(NAV_EXPANDED_STORAGE_KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === "string") : []
  } catch {
    return []
  }
}

export function writeExpandedGroups(
  expanded: string[],
  storage: StorageLike | null = defaultStorage(),
): void {
  try {
    storage?.setItem(NAV_EXPANDED_STORAGE_KEY, JSON.stringify(expanded))
  } catch {
    // квота/запрет — состояние живёт до перезагрузки
  }
}

/** Пункт меню активен на своём пути и на вложенных (/orders/123 → «Заказы»). */
export const isNavPathActive = (to: string, pathname: string): boolean =>
  pathname === to || pathname.startsWith(`${to}/`)

/** Ключ группы, в которой лежит открытый раздел. */
export function activeGroupKey(
  groups: { key: string; items: { to: string }[] }[],
  pathname: string,
): string | undefined {
  return groups.find((g) => g.items.some((item) => isNavPathActive(item.to, pathname)))?.key
}

export const toggleGroup = (expanded: string[], key: string): string[] =>
  expanded.includes(key) ? expanded.filter((k) => k !== key) : [...expanded, key]

/** Переход в свёрнутую группу раскрывает её (остальные — как оставил оператор). */
export const expandActive = (expanded: string[], active: string | undefined): string[] =>
  active && !expanded.includes(active) ? [...expanded, active] : expanded
